module.exports = __webpack_public_path__ + "static/media/AMG_Platform_Logo_dark.2f6544ed.svg";